import { Outlet } from 'react-router';
import BreadcrumbHeader, {
  BreadcrumbHeaderProps,
} from '../components/layout/BreadcrumbHeader';
import Content from '../components/layout/Content';
import { BreadcrumbContextProvider } from '../contexts/BreadcrumbContext';

const BreadcrumbLayout = (props: BreadcrumbHeaderProps) => (
  <BreadcrumbContextProvider>
    <BreadcrumbHeader {...props} />
    <Content>
      <Outlet />
    </Content>
  </BreadcrumbContextProvider>
);

export default BreadcrumbLayout;
